<template>
  <main>
    <section class="fk-contents">
      <p class="text-error">{{text.OrderFailed}}</p>
      <p class="mod-form-btn"><input type="button" :value="text.Return" class="btn-base btn-negative btn-quit" @click="execReturn"></p>
    </section>
  </main>
</template>

<script>
import CommonMixin from '@/mixins/CommonMixin'
import DisplayErrorMixin from '@/mixins/DisplayErrorMixin'
export default {
  name: 'FKMOOrderFailed',
  mixins: [ CommonMixin, DisplayErrorMixin ],
  data () {
    return {
      text: {
        OrderFailed: null,
        Return: null
      }
    }
  },
  methods: {
    execReturn: function () {
      this.$router.push({ name: 'OrderProcessing', params: { stopPollingTimer: true } })
    },
    initView: function () {
      this.text.OrderFailed = this.$i18n.t('Order.Failed')
      this.text.Return = this.$i18n.t('General.Return')
    }
  },
  mounted () {
    this.initView()
  },
  beforeUpdate () {
    this.restoreScaleRate('default') // 拡大縮小のロックを開放
  },
  destroyed () {
    this.restoreScaleRate('reset') // scaleをリセット
  }
}
</script>

<style scoped>
input[type=button] {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/OrderFailed.vue